var React = require('react');

function CheckSmallInline (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"currentColor","strokeLinejoin":"round","strokeWidth":"1.8","points":"2 13 8 19 22 5"}));
}

CheckSmallInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckSmallInline;

CheckSmallInline.default = CheckSmallInline;
